import { render } from "./ObjetoForm.vue?vue&type=template&id=4b00ae6a&scoped=true"
import script from "./ObjetoForm.vue?vue&type=script&lang=js"
export * from "./ObjetoForm.vue?vue&type=script&lang=js"

import "./ObjetoForm.vue?vue&type=style&index=0&id=4b00ae6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b00ae6a"]])

export default __exports__